(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-card-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-card-price')) {
  customElements.define('aw-card-price', class extends HTMLElement {
    connectedCallback() {
      this.syncSale = () => {
        clearTimeout(this.expiryTimer);
        const remaining = Number(this.dataset.saleEnd) - Date.now();
        this.querySelector('[data-aw-card-sale]').hidden = remaining <= 0;
        this.querySelector('[data-aw-card-regular]').hidden = remaining > 0;
        if (remaining > 0) this.expiryTimer = setTimeout(this.syncSale, Math.min(remaining + 10, 2147483647));
      };
      window.addEventListener('pageshow', this.syncSale);
      document.addEventListener('visibilitychange', this.syncSale);
      this.syncSale();
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      window.removeEventListener('pageshow', this.syncSale);
      document.removeEventListener('visibilitychange', this.syncSale);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aw-sale-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aw-sale-pricing')) {
  customElements.define('aw-sale-pricing', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('[data-section-type="product-template"]');
      const select = section && section.querySelector('#productSelect');
      const nativePrice = section && section.querySelector('#ProductPrice');
      const end = Number(this.dataset.saleEnd);
      this.updatePrice = () => {
        const active = Date.now() < end;
        const id = select && select.value;
        const panels = [...this.querySelectorAll('[data-aw-price-variant]')];
        const selected = panels.find(panel => panel.dataset.awPriceVariant === id);
        this.hidden = !active || !selected;
        panels.forEach(panel => { panel.hidden = panel !== selected; });
      };
      this.select = select;
      if (nativePrice) {
        this.observer = new MutationObserver(this.updatePrice);
        this.observer.observe(nativePrice, { childList: true, characterData: true, subtree: true });
      }
      if (select) select.addEventListener('change', this.updatePrice);
      window.addEventListener('pageshow', this.updatePrice);
      this.updatePrice();
      const remaining = end - Date.now();
      if (remaining > 0) this.expiryTimer = setTimeout(this.updatePrice, Math.min(remaining + 10, 2147483647));
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.select) this.select.removeEventListener('change', this.updatePrice);
      window.removeEventListener('pageshow', this.updatePrice);
      clearTimeout(this.expiryTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
